import { Component, Input, OnInit } from '@angular/core';
import { Schematic } from 'app/classes/schematic/schematic';

@Component({
  selector: 'app-schematics-detail-container',
  templateUrl: './schematics-detail-container.component.html',
  styleUrls: ['./schematics-detail-container.component.css'],
  standalone: false
})
export class SchematicsDetailContainerComponent implements OnInit {

  @Input()
  schematic: Schematic;

  _selectedNode: any;

  schematicCategory: 'equipment' | 'asset' | 'room' | 'floor' | 'schematic';

  co = 0;

  @Input()
  public set selectedNode(v: any) {
    console.log(v);
    this._selectedNode = v;
    this.co++;
    this.processNode();
  }
  public get selectedNode(): any {
    return this._selectedNode;
  }

  constructor() { }

  ngOnInit(): void {
  }


  processNode() {
    if (!this._selectedNode) {
      return;
    }

    const parts = this.selectedNode.data.split('-');

    if (parts.length === 2) {
      this.schematicCategory = 'schematic';

      return;
    }

    this.schematicCategory = parts[1];
  }
}
